<div class="input-container" [ngClass]="{error: hasError}">
  <ng-content select=".prefix"></ng-content>
  <ng-content select=".input"></ng-content>
  <label *ngIf="label">{{ label }} <span class="required">*</span></label>
</div>
